var l = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M8 12l2 2-2 2-2-2 2-2zM5 9l2 2-2 2-2-2 2-2zm6 0l2 2-2 2-2-2 2-2zM2 6l2 2-2 2-2-2 2-2zm6 0l2 2-2 2-2-2 2-2zm6 0l2 2-2 2-2-2 2-2zm-3-3l2 2-2 2-2-2 2-2zM5 3l2 2-2 2-2-2 2-2zm3-3l2 2-2 2-2-2 2-2z", "fill-rule": "evenodd" } }] }, name: "wowjoy", theme: "filled" };
export {
  l as default
};
